import styled from 'styled-components';

export const RefText = styled.div`
  display: inline-block;
  color: ${({ theme }) => theme.color.warning};
  cursor: pointer;
`;
